<template>
  <div>
    <widget heading="Workload Summary">
      <b-form inline @submit.prevent="" class="mb-2">
        <b-input-group class="filter-group">
          <b-form-select
            v-model="selectedTimePeriodId"
            :options="timePeriods"
            value-field="timePeriodId"
            text-field="description"
            @input="updateWorkloads"
            class="mb-2 mx-2"
          ></b-form-select>
        </b-input-group>
      </b-form>

      <dl class="row" v-if="!loading">
        <dd class="col-md-6">Total Approved</dd>
        <dt class="col-md-6">
          <router-link :to="{ name: 'workloads' }">{{
            summary.totalApproved
          }}</router-link>
        </dt>

        <dd class="col-md-6">Total Denied / Resubmit</dd>
        <dt class="col-md-6">
          <router-link :to="{ name: 'deniedWorkloads' }">{{
            summary.totalDenied
          }}</router-link>
        </dt>

        <dd class="col-md-6">Total Pending</dd>
        <dt class="col-md-6">
          <router-link :to="{ name: 'pendingWorkloads' }">{{
            summary.totalPending
          }}</router-link>
        </dt>
      </dl>
      <div v-else>Loading...</div>
    </widget>
  </div>
</template>

<script>
import { mapState } from "vuex";
import widget from "../../components/widget";
import reportsApi from "../../api/reports";
import timePeriodsApi from "../../api/timePeriods";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {
      summary: {},
      timePeriods: [],
      selectedTimePeriodId: null,
      loading: false,
    };
  },

  components: { widget },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },

  methods: {
    updateWorkloads: function (timePeriodId) {
      reportsApi.getWorkloadsSummary(timePeriodId).then((response) => {
        this.summary = response.data;
        this.loading = false;
      });
      //localStorage.timePeriodId = this.selectedTimePeriodId;
    },
  },

  created() {
    var that = this;
    this.loading = true;

    timePeriodsApi.getTimePeriods().then(function (response) {
      that.timePeriods = response.data;
      // if (localStorage.timePeriodId) {
      //   that.selectedTimePeriodId = localStorage.timePeriodId;
      //   //that.updateWorkloads(that.selectedTimePeriodId);
      // } else {
      timePeriodsApi.getCurrentTimePeriod().then(function (response) {
        that.selectedTimePeriodId = response.data.timePeriodId;
        that.updateWorkloads(that.selectedTimePeriodId);
      });
      // }
    });
  },
};
</script>

<style scoped>
</style>
